import axiosService from './axios.service';
import ResponseService from './response.service';

const login = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/login',
      isAuthorized: false,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const register = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/register',
      isAuthorized: false,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const ForgotPassword = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/password/forgot',
      isAuthorized: false,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const GoogleSignInInfo = async (_formData) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'https://www.googleapis.com/oauth2/v3/userinfo',
      isAuthorized: true,
      formData: _formData,
      externalUrl: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const linkedinAccessToken = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/linkedin/user_info',
      isAuthorized: false,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const linkedinUserInfo = async (_formData) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'https://api.linkedin.com/v2/me?projection=(id,firstName,emailAddress,lastName,profilePicture(displayImage~:playableStreams))',
      isAuthorized: true,
      formData: _formData,
      externalUrl: true,
      //externalContentType: "application/x-www-form-urlencoded",
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const verifyEmailToken = async (token) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'auth/verify_token/email_verification/' + token,
      isAuthorized: false,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const setNewPassword = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/password/set',
      isAuthorized: false,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const resetPassword = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/password/reset',
      isAuthorized: false,
      allowRequestCancellation: false,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const verifyToken = async (token) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'auth/verify_token/reset_password/' + token,
      isAuthorized: false,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const createPasswordEmail = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'auth/create_password',
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const initiateAgreement = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: `auth/agreement/${_formData?.type}`,
      isAuthorized: true,
      formData: { project_id: _formData?.project_id },
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const eSignaturesProjectAgreementProcess = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/project_agreement/generate',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const eSignaturesAgreementStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'get',
      url: `auth/agreement/${_formData.id}`,
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const checkUserExists = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/exists',
      isAuthorized: false,
      formData: _formData,
    };
    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};
const verifyTwoFA = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/two_factor/verify',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};
const validatePassword = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'auth/password/validate',
      isAuthorized: true,
      allowRequestCancellation: false,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const socialSignInRequest = async (socialType) => {
  try {
    let axiosData = {
      method: 'get',
      url: `auth/login/${socialType}`,
      isAuthorized: false,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const GoogleSignInCallback = async (queryParams, socialType) => {
  try {
    const apiURL = `auth/login/${socialType}/confirm?${new URLSearchParams(
      queryParams,
    )}`;

    let axiosData = {
      method: 'get',
      url: apiURL,
      isAuthorized: false,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const isValidSocialAuthToken = async (code) => {
  try {
    const apiURL = 'auth/login/token/verify';

    let axiosData = {
      method: 'post',
      url: apiURL,
      isAuthorized: false,
      formData: { code },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const AuthService = {
  login,
  register,
  ForgotPassword,
  GoogleSignInInfo,
  verifyEmailToken,
  eSignaturesProjectAgreementProcess,
  setNewPassword,
  resetPassword,
  verifyToken,
  linkedinAccessToken,
  linkedinUserInfo,
  createPasswordEmail,
  initiateAgreement,
  eSignaturesAgreementStatus,
  checkUserExists,
  verifyTwoFA,
  validatePassword,
  socialSignInRequest,
  GoogleSignInCallback,
  isValidSocialAuthToken,
};
export default AuthService;
